export function scan() {

  var scanNav = document.querySelectorAll(".scan__link");
  var scanEl = document.querySelectorAll(".scan__el");

  scanNav.forEach(function(e){
    e.addEventListener("click", function(r){
      let attr = r.currentTarget.dataset.scan;
      let style = `scan__${attr}`;

      console.log(attr);

      scanEl.forEach(element =>{
        element.classList.remove("scan__el--visible");
      });

      scanNav.forEach(element => {
        element.classList.remove("scan--active");
        // console.log(element);
      });
      document.querySelector(`.${style}`).classList.add("scan__el--visible");
      this.classList.add("scan--active");
    });
  });



  var constraints = {
    audio: false,
    video: {
      facingMode: { exact: "environment"}
    }
  };

  navigator.mediaDevices.getUserMedia(constraints)
    .then(function (mediaStream) {
      var video = document.querySelector('.scan__area');
      video.srcObject = mediaStream;
      video.onloadedmetadata = function (e) {
        video.play();
      };
    })
    .catch(function (err) {
      console.log(err.name + ": " + err.message);
    });


}
